var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "75%" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-toolbar",
        {
          staticClass: "add-modal-generar-recepcion",
          staticStyle: { "padding-left": "0px !important" },
          attrs: { dark: "", color: "primary" }
        },
        [
          _c(
            "v-flex",
            { attrs: { layout: "", "align-center": "", md6: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  on: { click: _vm.handlePopUp }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
              _c("v-toolbar-title", [
                _vm._v("\n        Generar Recepción\n      ")
              ])
            ],
            1
          ),
          _c("v-spacer")
        ],
        1
      ),
      _c(
        "v-container",
        { attrs: { fluid: "", white: "" } },
        [
          _c(
            "v-card",
            [
              _c("v-divider"),
              _c(
                "div",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            md12: "",
                            layout: "",
                            "justify-center": "",
                            wrap: "",
                            "my-5": ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm3: "", "mx-3": "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Actividad de despacho",
                                  "prepend-icon": "home_repair_service",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.data.nombre_add,
                                  callback: function($$v) {
                                    _vm.$set(_vm.data, "nombre_add", $$v)
                                  },
                                  expression: "data.nombre_add"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              attrs: { xs12: "", sm3: "", lg3: "", "mx-3": "" }
                            },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  label: "Fecha Recepción",
                                  disabled:
                                    _vm.validateFieldDisabled.fecha_recepcion
                                },
                                model: {
                                  value: _vm.objParam.fecha_recepcionador,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.objParam,
                                      "fecha_recepcionador",
                                      $$v
                                    )
                                  },
                                  expression: "objParam.fecha_recepcionador"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              attrs: { xs12: "", sm3: "", lg3: "", "mx-3": "" }
                            },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Recepcionado Por",
                                  "prepend-icon": "person",
                                  items: _vm.users,
                                  clearable: !_vm.validateFieldDisabled
                                    .recepcionado_por
                                },
                                model: {
                                  value: _vm.objParam.recepcionador,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objParam, "recepcionador", $$v)
                                  },
                                  expression: "objParam.recepcionador"
                                }
                              }),
                              _vm.fieldEmpty
                                ? _c("div", { staticClass: "pl-4" }, [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "red",
                                          "font-size": "12px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "* El campo Despachado Por es obligatiorio"
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-layout",
                    { staticClass: "mt-3", attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { xs8: "", sm8: "", md9: "" } }),
                      !_vm.validateFieldDisabled.button
                        ? _c(
                            "v-flex",
                            {
                              staticStyle: { "text-align": "end" },
                              attrs: { xs4: "", sm4: "", md3: "" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-volver white--text",
                                  on: { click: _vm.handlePopUp }
                                },
                                [_vm._v("Cancelar")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-grabar white--text",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleUpdate()
                                    }
                                  }
                                },
                                [_vm._v("Guardar")]
                              )
                            ],
                            1
                          )
                        : _c(
                            "v-flex",
                            {
                              staticStyle: { "text-align": "end" },
                              attrs: { xs4: "", sm4: "", md3: "" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-volver white--text",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleClosed({})
                                    }
                                  }
                                },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("Confirmation", {
                attrs: {
                  show: _vm.dialogPopUp,
                  titulo: "Confirmación",
                  mensaje:
                    "Al cerrar esta ventana toda la información ingresada se perderá. ¿Está seguro que desea cerrar sin guardar?",
                  textoBtnSi: _vm.$t("No Guardar"),
                  textoBtnNo: _vm.$t("Continuar Creando")
                },
                on: {
                  modalConfirmationEmit: function($event) {
                    return _vm.showPopuP($event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }